import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LoginService } from '../../../service/Login/login.service';
import { AppComponent } from '../../../app.component';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  sidebarOpen = true;
  isSubmenuOpen = false;
  isSubmenuReportOpen = false;
  constructor(
    private http: HttpClient,
    private loginService: LoginService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    public router: Router,
    private toaster: ToastrService, private appcomponent: AppComponent) {


  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    this.appcomponent.sidebartoggle(this.sidebarOpen);

  }

  toggleSubmenu(event: MouseEvent) {
    event.preventDefault();  // Prevent the default link behavior
    this.isSubmenuOpen = !this.isSubmenuOpen;
  }

  toggleSubmenuReport(event: MouseEvent) {
    event.preventDefault();  // Prevent the default link behavior
    this.isSubmenuReportOpen = !this.isSubmenuReportOpen;
  }

  reloadPage() {
    window.location.href = '/order-history';
}

  logout() {

    if (isPlatformBrowser(this.platformId)) {

      if (localStorage.getItem('token') != null) {

        this.loginService.GoLogout().subscribe({
          next: (res) => {
            // console.log(res.message);

            // if (res.message) {
            localStorage.removeItem('token');
            this.appcomponent.user_type = null;
            this.appcomponent.ngOnInit();
            this.router.navigateByUrl('/');

            // }

          }, error: (err) => {
            if (err.status === 422 && err.error.errors) {
              const validationErrors = err.error.errors;

              Object.keys(validationErrors).forEach(key => {
                const errorMessages = validationErrors[key];
                this.toaster.error(errorMessages[0]);
                return
              });
            } else {
              this.toaster.error('An error occurred while Log Out');
            }
          }
        });

      }
    }

  }

  // add product background condition
get isActiveRoute(): boolean {
  return this.router.url === '/add-product' || 
         this.router.url === '/product-bulk-upload' || 
         this.router.url === '/manage-combos';
}

get isActiveReportRoute(): boolean {
  return this.router.url === '/highest-bid-report' || 
         this.router.url === '/highest-bid'  
}

}
